<template>
    <div class="__comments">
        <div class="__comment mt-2 rounded" v-for="comment in rating" :key="comment.id">
            <div class="font-white p-2">
                <div class="__commfent_user font-weight-bold">{{comment.user.name + ' ' + comment.user.lname}}</div>
                <div class="__comment font-weight-light">
                    {{comment.comment}}
                </div>
                <div class="__published text-right"> {{comment.created_at | timeDate}}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Comments',
    props:{
        rating: Array
    },
    data() {
        return {
            
        }
    },
    methods:{

    }
}
</script>


// WEBPACK FOOTER //
// src/components/#public/curse/components/content/Comments.vue